import { getTelemetryClient } from '@doordash/telemetry-js';
var WORK_PORTAL_ENTITY_ID = 'b3b27ad7-4ef4-4e2e-ad99-f5b1d2154d69';
export var identifyConsumer = function (id) {
    var _a;
    (_a = getTelemetryInstance()) === null || _a === void 0 ? void 0 : _a.identify(id);
};
export var getTelemetryInstance = function () {
    var instanceForWorkPortal = getTelemetryClient(WORK_PORTAL_ENTITY_ID);
    instanceForWorkPortal.setConsent(true);
    return instanceForWorkPortal;
};
